import React, { useState, useEffect } from 'react';
import authService from './api-authorization/AuthorizeService'
import axios from 'axios'
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import TextField from '@mui/material/TextField';
import LoadingButton from '@mui/lab/LoadingButton';
import Grid from '@mui/material/Grid';
import MUIDataTable, { ExpandButton } from "mui-datatables";
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { CacheProvider } from '@emotion/react';
import createCache from '@emotion/cache';
import { Link } from "react-router-dom";

const muiCache = createCache({
    key: 'mui-datatables',
    prepend: true,
});

export default function DownloadRecords() {
    const [token, setToken] = useState("");
    const [days, setDays] = useState(1);
    const [status, setStatus] = useState("");
    const [appData, setAppData] = useState([]);
    const [loading, setLoading] = useState(false);
    const apiPath = '/api/DownloadRecords?days=';

    const columns = [
        {
            name: '',
            label: '',
            options: {
                filter: false,
                display: true,
                viewColumns: false,
                customBodyRender: (value, tableMeta, update) => {
                    let rowIndex = Number(tableMeta.rowIndex) + 1;
                    return (
                        <div style={{ textAlign: "right" }}><span>{rowIndex}</span></div>
                    )
                }
            }
        },
        {
            name: "downloadTime",
            label: "Download Time",
            options: {
                sort: true,
                sortThirdClickReset: true,
                customBodyRender: (value, tableMeta, updateValue) => (
                    <div style={{ textAlign: "left" }}>{(new Date(value + "Z")).toLocaleString()}</div>
                )
            }
        },
        {
            name: "gameOwnerName",
            label: "Game Owner",
            options: {
                filter: true,
                filterType: 'multiselect',
                sort: true,
                sortThirdClickReset: true,
                display: true,
                viewColumns: true,
                customBodyRender: (value, tableMeta, updateValue) => {
                    let record = appData[tableMeta.currentTableData[tableMeta.rowIndex].index];
                    //let originalIndex = tableMeta.currentTableData[tableMeta.rowIndex].index;
                    //let rowPlayer = appData[originalIndex];
                    let idType = record.gameOwnerFIDEId > 0 ? "FIDE" : "USCF";
                    let id = record.gameOwnerFIDEId > 0 ? record.gameOwnerFIDEId : record.gameOwnerUSCFId;


                    return (
                        //<div style={{ textAlign: "left" }}>
                        //    {record.gameOwnerUSCFId >0 ? (<a href={'http://www.uschess.org/msa/MbrDtlMain.php?' + record.gameOwnerUSCFId} target='_blank' rel='noreferrer'>{value}</a>) :
                        //        (record.gameOwnerFIDEId >0 ? (<a href={'https://ratings.fide.com/profile/' + record.gameOwnerFIDEId} target='_blank' rel='noreferrer'>{value}</a>) : value)}
                        //</div>

                        <Link target="_blank" to={'/players/details?idtype='+idType+'&id='+id} className="button">{value}</Link>

                    );
                }
            }
        },
        {
            name: "gameOwnerFIDEId",
            label: "FIDE ID",
            options: {
                filter: true,
                filterType: 'multiselect',
                sort: true,
                sortThirdClickReset: true,
                display: false,
                viewColumns: true,
                customBodyRender: (value, tableMeta, updateValue) => (
                    <div style={{ textAlign: "center" }}>{value != -1 ? (<a href={'https://ratings.fide.com/profile/' + value} target='_blank' rel='noreferrer'>{value}</a>) : (-1)}</div>
                )
            }
        },
        {
            name: "gameOwnerUSCFId",
            label: "USCF ID",
            options: {
                filter: true,
                filterType: 'multiselect',
                sort: true,
                sortThirdClickReset: true,
                display: false,
                viewColumns: true,
                customBodyRender: (value, tableMeta, updateValue) => (
                    <div style={{ textAlign: "center" }}>{value != -1 ? (<a href={'http://www.uschess.org/msa/MbrDtlMain.php?' + value} target='_blank' rel='noreferrer'>{value}</a>) : (-1)}</div>
                )
            }
        },
        {
            name: "numberOfGames",
            label: "Games",
            options: {
                filter: true,
                filterType: 'multiselect',
                sort: true,
                sortThirdClickReset: true
            }
        },
        {
            name: "downloadByName",
            label: "Downloader",
            options: {
                filter: true,
                filterType: 'multiselect',
                sort: true,
                sortThirdClickReset: true,
                customBodyRender: (value, tableMeta, updateValue) => {
                    let record = appData[tableMeta.currentTableData[tableMeta.rowIndex].index];
                    let idType = record.downloadByFIDEId > 0 ? "FIDE" : "USCF";
                    let id = record.downloadByFIDEId > 0 ? record.downloadByFIDEId : record.downloadByUSCFId;
                    return (
                        //<div style={{ textAlign: "left" }}>
                        //    {record.downloadByUSCFId != -1 ? (<a href={'http://www.uschess.org/msa/MbrDtlMain.php?' + record.downloadByUSCFId} target='_blank' rel='noreferrer'>{value}</a>) :
                        //        (record.downloadByFIDEId != -1 ? (<a href={'https://ratings.fide.com/profile/' + record.downloadByFIDEId} target='_blank' rel='noreferrer'>{value}</a>) : value)}
                        //</div>
                        <div style={{ textAlign: "left" }}>
                            {record.downloadByUSCFId != -1 ? (<Link target="_blank" to={'/players/details?idtype=USCF&id=' + record.downloadByUSCFId} className="button">{value}</Link>) :
                                (record.downloadByFIDEId != -1 ? (<Link target="_blank" to={'/players/details?idtype=FIDE&id=' + record.downloadByFIDEId} className="button">{value}</Link>) : value)}
                        </div>
                    );
                }
            }
        },
        {
            name: "downloadByFIDEId",
            label: "FIDE ID",
            options: {
                filter: true,
                filterType: 'multiselect',
                sort: true,
                sortThirdClickReset: true,
                display: false,
                viewColumns: true,
                customBodyRender: (value, tableMeta, updateValue) => (
                    <div style={{ textAlign: "center" }}>{value != -1 ? (<a href={'https://ratings.fide.com/profile/' + value} target='_blank' rel='noreferrer'>{value}</a>) : (-1)}</div>
                )
            }
        },
        {
            name: "downloadByUSCFId",
            label: "USCF ID",
            options: {
                filter: true,
                filterType: 'multiselect',
                sort: true,
                sortThirdClickReset: true,
                display: false,
                viewColumns: true,
                customBodyRender: (value, tableMeta, updateValue) => (
                    <div style={{ textAlign: "center" }}>{value != -1 ? (<a href={'http://www.uschess.org/msa/MbrDtlMain.php?' + value} target='_blank' rel='noreferrer'>{value}</a>) : (-1)}</div>
                )
            }
        },
        {
            name: "downloadFromIP",
            label: "Download IP",
            options: {
                filter: true,
                filterType: 'multiselect',
                sort: true,
                sortThirdClickReset: true,
                display: false,
                viewColumns: true
            }
        },
    ];

    const options = {
        setTableProps: () => {
            return {
                size: 'small',
            };
        },
        filter: true,
        filterType: 'dropdown',
        responsive: 'standard',
        expandableRows: false,
        selectableRows: 'none',
        expandableRowsOnClick: false,
        expandableRowsHeader: false,
        download: false,
        print: false,
        rowsPerPage: 200,
        rowsPerPageOptions: [5, 10, 15, 25, 50, 100, 200],
        jumpToPage: true,
        fixedHeaderOptions: {
            xAxis: true,
            yAxis: true
        },
        resizableColumns: false,
        isRowExpandable: (dataIndex, expandedRows) => {
            // Prevent expand/collapse of any row if there are 4 rows expanded already (but allow those already expanded to be collapsed)
            if (expandedRows.data.length > 4 && expandedRows.data.filter(d => d.dataIndex === dataIndex).length === 0)
                return false;
            return true;
        },
        rowsExpanded: [],
        onRowExpansionChange: (curExpanded, allExpanded, rowsExpanded) =>
            console.log(curExpanded, allExpanded, rowsExpanded),
    };

    const theme = createTheme({
        overrides: {
            MUIDataTableSelectCell: {
                expandDisabled: {
                    // Soft hide the button.
                    visibility: 'hidden',
                },
            },
        },
    });

    const components = {
        ExpandButton: function (props) {
            return <ExpandButton {...props} />;
        },
    };

    useEffect(async () => {
        setToken(await authService.getAccessToken());
    }, []); //Runs only on the first render

    const getAppData = async (e, playerName) => {
        e.preventDefault();
        setToken(await authService.getAccessToken());
        var headers = {
            headers: { 'Authorization': `Bearer ${token}` }
        }

        axios.get(apiPath + days, headers).then((response) => {
            setAppData(response.data);
            setLoading(false);
            setStatus("");
        }).catch((error) => {
            setLoading(false);
            setStatus("Error - Please check log for details.");
            console.log(JSON.stringify(error));
        });
    };
    
    return (
        <Box sx={{ pt: 2, pb:2 }}>
            <Grid container direction="row" rowSpacing={1} columnSpacing={1} align-items="flex-end">
            <Grid item xs={12} lg={7} >
                <TextField
                    size="small"
                    fullWidth
                    id="outlined-number"
                    label={"Downloads In The Past " + days +" Day(s)"}
                    type="number"
                    inputProps={{min:1,max:365 }}
                    InputLabelProps={{
                        shrink: true
                    }}
                    value={days}
                    onChange={(e) => setDays(e.target.value)}
                />
            </Grid>
            <Grid item xs={12} lg={5}>
                <Stack spacing={1} direction="row" justifyContent="end">
                        <LoadingButton fullWidth onClick={async (e) => { e.preventDefault(); await setLoading(true); await getAppData(e, days); }} loading={loading} loadingIndicator="Loading..." variant="contained">Show Downloads of Past {days} Day(s)</LoadingButton>
                        {/*<Button variant="outlined" onClick={async (e) => { e.preventDefault(); await setAppData([]); await setStatus(""); }}>{"Clear"}</Button>*/}
                </Stack>
            </Grid>
           
            <Grid item xs={12}>
                <div>
                    <label style={{ color: 'red' }}>{status}</label>
                </div>
            </Grid>
                {/*{appData.length > 0 &&*/}
                {appData.length > 0 &&
                    <Grid item xs={12}>
                        <CacheProvider value={muiCache}>
                            <ThemeProvider theme={theme}>
                                <MUIDataTable
                                /*title={appData.length + " downloads in the past " + days + " day(s)"}*/
                                title={
                                    <div>
                                        <Button variant="contained" color="secondary"
                                            onClick={async (e) => { e.preventDefault(); await setAppData([]); /*await setSelectedUser(); await setSearchString("")*/ }}>
                                            {"Clear Results (" + appData.length + ")"}
                                        </Button>
                                    </div>
                                }
                                    data={appData}
                                    columns={columns}
                                    options={options}
                                    components={components}
                            />

                            </ThemeProvider>
                        </CacheProvider>
                    </Grid>
                }
            </Grid>
            
        </Box>
    )
}
